var nanobar = new Nanobar({
    id: 'nanobar',
    target: document.getElementById('top')
});

var filtersViewModel = {
    cityId: ko.observable(null),

    areas: ko.observableArray([]),

    areaUrl: ko.observable(null),

    noAreaSelected: 1000,

    zones: ko.observableArray([]),

    zoneId: ko.observable(null),

    geographicalAreas: ko.observableArray([]),

    geographicalAreaId: ko.observable(null),

    name: ko.observable(""),

    pools: ko.observable([]),

    faq: ko.observable([]),

    // noUiSlider
    priceSlider: null,

    price: ko.observable({
        min: 10000,
        max: 600000,
        min_default: 10000,
        max_default: 600000
    }),

    // Pool Width
    poolWidthSlider: null,

    poolWidth: ko.observable({
        min: 5,
        max: 35,
        min_default: 5,
        max_default: 35
    }),

    // Pool Length
    poolLengthSlider: null,

    poolLength: ko.observable({
        min: 10,
        max: 70,
        min_default: 10,
        max_default: 70
    }),

    // Pool Depth
    poolDepthSlider: null,

    poolDepth: ko.observable({
        min: 0.5,
        max: 7,
        min_default: 0.5,
        max_default: 7
    }),

    saensTimeSlider: null,

    saensTime: ko.observable({
        min: 0,
        max: 24,
        min_default: 0,
        max_default: 24
    }),

    pageHeaderTitle: ko.observable(),

    paginator: ko.observable(''),

    description: ko.observable({
        title: '',
        content: ''
    }),

    tags: ko.observableArray(),

    noTagSelected: 1000,

    f_gender: ko.observable(''),

    f_type: ko.observable(''),

    services: ko.observableArray(),

    selectedService: ko.observable(),

    allServiceType: 1000,

    serviceCategories: ko.observableArray(),

    selectedServiceCategory: ko.observable(),

    allServiceCategory: 1000,

    servicesByCategory: ko.observableArray(),

    nanobarInterval: null,

    nanobarProgress: 0,

    afterFirstRequest: ko.observable(false),

    activeSubmit: true,

    statusSell: ko.observable(false),

    attributes: ko.observableArray(),

    hasNotOnlyOneAttribute: 1000,

    poolsCount: ko.observable(0),
    poolsCountFa: ko.observable(0),

    showAjaxDescriptions: ko.observable(false),
    showAjaxFaqs: ko.observable(false),

    sortList: ko.observableArray([]),
    sortedBy: ko.observable(''),
    defaultSort: 'discount',

    citySelect2: null,

    hasServicesSuggestLinks: ko.observable(false),

    viewAttributes: ko.pureComputed({
        read: function() {
            if (filtersViewModel.attributeSearch().length > 0) {
                var attributes = [];
                $.each(filtersViewModel.attributes(), function(index, attr) {
                    if (attr.name.indexOf(filtersViewModel.attributeSearch()) >= 0) {
                        attributes.push(attr);
                    }
                })
                return attributes;
            } else {
                return filtersViewModel.attributes();
            }
        }
    }),

    selectedAttributes: ko.observableArray(),

    attributeSearch: ko.observable(''),

    loading: ko.observable(false),

    statusSellTag: ko.observable({
        type: 'status_sell',
        value: 1,
        title: 'فروش فعال پول تیکت'
    }),

    submitSearchInput: function() {
        this.updateName();
        // this.clearFilters(['name'], false);
        filtersViewModel.request(filtersViewModel.buildUrl(), true);
    },

    submitFilter: function() {
        if (!filtersViewModel.activeSubmit)
            return false;

        filtersViewModel.disableButton('#update-price');
        filtersViewModel.priceChange();

        filtersViewModel.disableButton('#update-time');
        filtersViewModel.saensTimeChange();

        filtersViewModel.disableButton('#update-dimension');
        filtersViewModel.poolWidthChange();
        filtersViewModel.poolLengthChange();
        filtersViewModel.poolDepthChange();

        filtersViewModel.request(filtersViewModel.buildUrl(), true);
    },

    buildUrl: function() {
        var baseUrl = filtersViewModel.buildBaseUrl();
        baseUrl = filtersViewModel.buildCityUrl(baseUrl);
        baseUrl = filtersViewModel.buildAttrUrl(baseUrl);
        baseUrl = filtersViewModel.buildAreaUrl(baseUrl);
        baseUrl = filtersViewModel.buildQueryString(baseUrl);

        return baseUrl;
    },

    buildBaseUrl: function() {
        let serviceUrl = filtersViewModel.buildServiceUrl();
        return `${window.BASE_URL}/${serviceUrl}`;
    },

    buildServiceUrl: function() {
        const { printServiceCategory, printService, selectedService, allServiceType } = filtersViewModel;
        if (selectedService() !== allServiceType) {
            serviceUrl = printService();
        } else {
            serviceUrl = printServiceCategory();

            // If has Attribute OR Area OR Tag, set `all` for service url
            if (filtersViewModel.isAttributeSelected() ||
                filtersViewModel.isAreaSelected() ||
                filtersViewModel.isTagSelected() || 
                filtersViewModel.isCitySelected()) 
            {
                serviceUrl = serviceUrl + "/all"; 
            }
        }

        return serviceUrl;
    },

    isAttributeSelected: function() {
        return filtersViewModel.selectedAttributes().length > 0;
    },

    isAreaSelected: function() {
        return this.areaUrl() != 'all';
    },

    isTagSelected: function() {
        return filtersViewModel.tags().some(obj => obj.type === 'tag');
    },

    isCitySelected: function() {
        return filtersViewModel.cityId() && filtersViewModel.cityId() !== 'all';
    },

    printServiceCategory: function() {
        return filtersViewModel.getUrlByServiceCategory(filtersViewModel.selectedServiceCategory());
    },

    printService: function() {
        return filtersViewModel.getUrlByServiceType(filtersViewModel.selectedService());
    },

    getUrlByServiceType: function(serviceType) {
        const foundItem = filtersViewModel.services().find(service => service.service_type === serviceType);
        return foundItem ? foundItem.url : 'all';
    },

    getUrlByServiceCategory: function(categoryId) {
        const foundItem = filtersViewModel.serviceCategories().find(category => category.service_category_id === categoryId);
        return foundItem ? foundItem.url : 'search';
    },

    getCategoryByServiceType: function(serviceType) {
        const foundItem = filtersViewModel.services().find(service => service.service_type === serviceType);
        return foundItem ? foundItem.service_category_id : filtersViewModel.allServiceCategory;
    },

    buildCityUrl: function(baseUrl) {
        if (filtersViewModel.cityId() && filtersViewModel.cityId() !== 'all') {
            baseUrl += '/' + filtersViewModel.cityId();
        } else if (filtersViewModel.selectedAttributes().length == 1) {
            baseUrl += '/all';
        }

        return baseUrl;
    },

    buildAttrUrl: function(baseUrl) {
        // If only one attribute is selected, add it to URL
        if (filtersViewModel.selectedAttributes().length !== 1)
            return baseUrl;

        var selectedAttrId = filtersViewModel.selectedAttributes()[0];
        var selectedAttrObj = filtersViewModel.attributes().find((e) => e.attribute_id == selectedAttrId);

         if (selectedAttrObj.url) {
            baseUrl += '/attr/' + selectedAttrObj.url;
        }

        return baseUrl;
    },

    buildAreaUrl: function(baseUrl) {
        if (this.areaUrl() === 'all')
            return baseUrl;

        let area = filtersViewModel.tags().filter((obj) => obj.type === 'area')[0];

        if (area && area.value) {
            baseUrl += '/area/' + area.value;
        }

        return baseUrl;
    },

    buildQueryString: function(baseUrl) {
        var query = [];

        query = filtersViewModel.collectTags(query);

        let sort = this.getSort();
        if (sort.length > 0) {
            query.push(sort);
        }

        return query.length > 0 ? baseUrl + '?' + query.join('&') : baseUrl;
    },

    cityChange: function(d, e) {
        this.deselectAreaAndZone();
        this.cityId(e.target.value);
        this.removeTagWhere(['type', 'city']);

        if (this.cityId() && this.cityId() !== 'all') {
            this.tags.push({
                type: 'city',
                value: this.cityId(),
                title: $('#filter-city option:selected').text(),
                ignore_query: true
            });
        }

        this.refreshAreas();
    },

    deselectAreaAndZone: function() {
        this.areaUrl('all');
        this.zoneId('all');
        this.geographicalAreaId('all');

        this.removeTagWhere(['type', 'area']);
        this.removeTagWhere(['type', 'zone']);
        this.removeTagWhere(['type', 'geographical_area']);
    },

    areaChange: function() {
        this.removeTagWhere(['type', 'area']);

        if (this.areaUrl() && this.areaUrl() !== 'all') {
            this.tags.push({
                type: 'area',
                value: this.areaUrl(),
                title: $('#filter-area option:selected').text(),
                ignore_query: true
            });
        }
    },

    zoneChange: function() {
        this.removeTagWhere(['type', 'zone']);

        if (this.zoneId() && this.zoneId() !== 'all') {
            this.tags.push({
                type: 'zone',
                value: this.zoneId(),
                title: $('#filter-zone option:selected').text()
            });
        }
    },

    geographicalAreaChange: function() {
        this.removeTagWhere(['type', 'geographical_area']);

        if (this.geographicalAreaId() && this.geographicalAreaId() !== 'all') {
            this.tags.push({
                type: 'geographical_area',
                value: this.geographicalAreaId(),
                title: $('#filter-geographical-area option:selected').text()
            });
        }
    },

    refreshAreas: function(doneCallback) {
        let that = this;

        if (this.cityId() == 'all') {
            this.areas(this.allAreaOption());
            this.zones(this.allZoneOption());
            this.geographicalAreas(this.allGeographicalAreaOption());
            return;
        }

        $.ajax({
            url: window.BASE_URL + "/pools/areas/list",
            data: {city: this.cityId()},
            method: 'GET',
            dataType: "json",
            cache: true
        }).done(function(data) {
            if (!data.status) {
                that.areas(that.allAreaOption());
                that.zones(that.allZoneOption());
                that.geographicalAreas(that.allGeographicalAreaOption());
            }

            that.areas(that.allAreaOption().concat(data.areas));
            that.zones(that.allZoneOption().concat(data.zones));
            that.geographicalAreas(that.allGeographicalAreaOption().concat(data.geographical_areas));

            if (that.afterFirstRequest()) {
                that.areaUrl('all');
                that.zoneId('all');
                that.geographicalAreaId('all');
            }

            if (doneCallback != undefined)
                doneCallback();

        }).fail(function(data) {
            that.areas(that.allAreaOption());
            return false;
        });
    },

    allAreaOption: function() {
        return [{'name': 'همه محله‌ها', 'url': 'all'}];
    },

    allZoneOption: function() {
        return [{'name': 'همه منطقه‌ها', 'attribute_id': 'all'}];
    },

    allGeographicalAreaOption: function() {
        return [{'name': 'همه منطقه‌های جغرافیایی', 'attribute_id': 'all'}];
    },

    collectTags: function(query) {
        var lengthOfAttributes = filtersViewModel.lengthOfAttributes();
        var attrs = '';
        $.each(filtersViewModel.tags(), function(index, tag) {
            if (tag.ignore_query === true)
                return;

            // Add array query string e.g: muliple attributes
            if (typeof tag.queryStringType !== 'undefined' && tag.queryStringType == 'array') {
                switch(tag.type) {
                    case 'attr':
                        if (lengthOfAttributes > 1) {
                            if (attrs.length == 0)
                                attrs = 'attrs=' + encodeURIComponent(tag.value);
                            else
                                attrs += (',' + encodeURIComponent(tag.value));
                            break;
                        }
                }

            } else if (typeof tag.query !== 'undefined') { // Add whole query string
                query.push(tag.query);

            } else { // Make query string from tags
                var tagType = tag.type;
                if (tagType == 'name')
                    tagType = 'q';

                query.push(encodeURIComponent(tagType) + '=' + encodeURIComponent(tag.value));
            }
        });

        if (attrs.length > 0)
            query.push(attrs);

        return query;
    },

    lengthOfAttributes: function() {
        return filtersViewModel.tags().filter((obj) => obj.type === 'attr').length;
    },

    addToQuery: function(name, value, query) {
        query.push(name + '=' + value);
        return query;
    },

    request: function(url, pushState, done) {
        filtersViewModel.requestStart();

        if (filtersViewModel.notSupportPushState())
            return filtersViewModel.refreshPage(url);

        if (pushState) {
            filtersViewModel.pushState(url);
        }

        $.ajax({
            url: url,
            dataType: 'json',
            type: 'GET',
            cache: false,
            success: function(data) {
                filtersViewModel.requestFinish();

                filtersViewModel.changeTitle(data.title);
                filtersViewModel.viewRender(data);
                carouselSlider();

                if (typeof done !== 'undefined')
                    done(data);
            },
            error: function() {
                return filtersViewModel.refreshPage(url);
            }
        });
    },

    /**
     * @source Modernizr
     */
    notSupportPushState: function() {
        var ua = navigator.userAgent;

        // We only want Android 2 and 4.0, stock browser, and not Chrome which identifies
        // itself as 'Mobile Safari' as well, nor Windows Phone (issue #1471).
        if ((ua.indexOf('Android 2.') !== -1 ||
            (ua.indexOf('Android 4.0') !== -1)) &&
            ua.indexOf('Mobile Safari') !== -1 &&
            ua.indexOf('Chrome') === -1 &&
            ua.indexOf('Windows Phone') === -1 &&
            // Since all documents on file:// share an origin, the History apis are
            // blocked there as well
            location.protocol !== 'file:'
        ) {
            return true;
        }

        // Return the regular check
        return !(window.history && 'pushState' in window.history);
    },

    refreshPage: function(url) {
        window.location = url;
    },

    pushState: function(url) {
        window.history.pushState(null, null, url);
    },

    changeTitle: function(title) {
        document.title = title;
    },

    viewRender: function(data) {
        filtersViewModel.pools(data.pools);
        filtersViewModel.poolsCount(data.poolsCount);
        $('.filters .backend-render').remove();
        filtersViewModel.poolsCountFa(data.poolsCount.toString().toPersianDigits());
        filtersViewModel.paginator(data.paginator);
        document.getElementById("search-breadcrumb").innerHTML = data.breadcrumb;

        // Update seo nav links
        document.getElementById("seo-nav-links-section").innerHTML = data.seoNavLinks;
        seoNavLinksCarousel();

        // Update Services suggest links
        let servicesSuggestLinkSection = document.getElementById("services-suggest-links-section");
        servicesSuggestLinkSection.innerHTML = '';
        if (data.servicesSuggestLinks.length > 0) {
            filtersViewModel.hasServicesSuggestLinks(true);
            servicesSuggestLinkSection.innerHTML = data.servicesSuggestLinks;
        } else {
            filtersViewModel.hasServicesSuggestLinks(false);
        }
        servicesSuggestLinksCarousel();

        if (data.description_content) {
            $('#static-description').remove();
            filtersViewModel.description({
                title: data.description_title,
                content: data.description_content
            });
        } else {
            filtersViewModel.description({
                title: data.title,
                content: ''
            });
        }

        if (data.faq) {
            filtersViewModel.faq(data.faq);
        }

        $('.pool-card').fadeIn();

        $('.filter-list-slider-image').owlCarousel({
            items: 1,
            rtl: true,
            autoplay: false,
            nav: false,
            loop: false,
            lazyLoad: true,
        });

        /**
         * Show SeoDescription contents
         */
        let showAjaxDescriptions = (data.page < 2) && (filtersViewModel.description().content.length > 0);
        filtersViewModel.showAjaxDescriptions(showAjaxDescriptions);

        let showAjaxFaqs = (data.page < 2) && (filtersViewModel.faq().length > 0);
        filtersViewModel.showAjaxFaqs(showAjaxFaqs);

        // $('html,body').scrollTop(0);
    },

    requestStart: function() {
        filtersViewModel.loading(true);
        filtersViewModel.nanobarStart();
        this.description({
            title: '',
            content: ''
        });

        $('#pools-page').prepend('<div class="loading-overlay"></div>');
    },

    requestFinish: function() {
        filtersViewModel.loading(false);
        filtersViewModel.nanobarFinish();

        $('.pool-card-backend-render').remove();
        $('.pagination-container.backend-render').remove();

        $('.description-content.backend-render').remove();

        $('#pools-page .loading-overlay').remove();
    },

    nanobarStart: function() {
        filtersViewModel.nanobarProgress = 20;
        nanobar.go(filtersViewModel.nanobarProgress);

        filtersViewModel.nanobarInterval = setInterval(function() {
            nanobar.go(filtersViewModel.nanobarProgress += 2);
        }, 1500);
    },

    nanobarFinish: function() {
        filtersViewModel.nanobarProgress = 100;
        nanobar.go(filtersViewModel.nanobarProgress);

        clearInterval(filtersViewModel.nanobarInterval);
    },

    statusSellChange: function() {
        if (filtersViewModel.statusSell()) {
            filtersViewModel.tags.push(filtersViewModel.statusSellTag());
            filtersViewModel.submitFilter();
        } else {
            filtersViewModel.removeTag(filtersViewModel.statusSellTag());
        }
    },

    genderChange: function() {
        filtersViewModel.submitFilter();
    },

    genderSet: function(submit) {
        let value = 'همه';
        switch (filtersViewModel.f_gender()) {
            case 0: case '0': value = 'آقایان'; break;
            case 1: case '1': value = 'بانوان'; break;
        }

        filtersViewModel.removeTagWhere(['type', 'gender']);
        if (filtersViewModel.f_gender() !== 'all') {
            filtersViewModel.tags.push({
                type: 'gender',
                value: filtersViewModel.f_gender(),
                title: value
            });
        }

        if (submit) {
            filtersViewModel.submitFilter();
        }
    },

    typeChange: function() {
        filtersViewModel.submitFilter();
    },

    typeSet: function(value) {
        filtersViewModel.removeTagWhere(['type', 'type']);
        if (filtersViewModel.f_type() && filtersViewModel.f_type() !== 'all') {
            filtersViewModel.tags.push({
                type: 'type',
                value: filtersViewModel.f_type(),
                title: value
            });
        }
    },

    removeTagWhere: function(fields, array) {
        array = typeof array !== 'undefined' ? array : false;

        var find = true;

        if (array) {
            $.each(filtersViewModel.tags(), function(index, tag) {
                $.each(filtersViewModel.tags(), function(index, tag) {
                    find = true;
                    for (var i = 0; i < fields.length; i += 2) {
                        if (tag[fields[i]] !== fields[i + 1]) {
                            find = false;
                        }
                    }

                    if (find) {
                        filtersViewModel.tags.splice(index, 1);
                        return false;
                    }
                });
            });
        } else {
            $.each(filtersViewModel.tags(), function(index, tag) {
                find = true;
                for (var i = 0; i < fields.length; i += 2) {
                    if (tag[fields[i]] !== fields[i + 1]) {
                        find = false;
                    }
                }

                if (find) {
                    filtersViewModel.tags.splice(index, 1);
                    return false;
                }
            });
        }
    },

    removeTag: function(tag, doSubmit = true) {
        filtersViewModel.tags.remove(tag);

        switch (tag.type) {
            case 'service_category':
                filtersViewModel.selectedServiceCategory(filtersViewModel.allServiceCategory);
                filtersViewModel.serviceCategoryChange();
                break;

            case 'service':
                filtersViewModel.selectedService(filtersViewModel.allServiceType);
                filtersViewModel.serviceChange();
                break;

            case 'gender':
                filtersViewModel.f_gender('all');
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'type':
                filtersViewModel.f_type('all');
                break;

            case 'vicinity':
                filtersViewModel.submitFilter();
                break;

            case 'attr':
                filtersViewModel.selectedAttributes.remove(tag.attribute_id);
                filtersViewModel.attributeChange();
                break;

            case 'tag':
                filtersViewModel.submitFilter();
                break;

            case 'name':
                filtersViewModel.name('');
                filtersViewModel.submitFilter();
                break;

            case 'saens_time':
                filtersViewModel.saensTime().min = 0;
                filtersViewModel.saensTime().max = 24;
                filtersViewModel.saensTimeSlider.noUiSlider.set([filtersViewModel.saensTime().min_default + 6, filtersViewModel.saensTime().max_default + 6]);
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'price':
                filtersViewModel.price().min = filtersViewModel.price().min_default;
                filtersViewModel.price().max = filtersViewModel.price().max_default;
                filtersViewModel.priceSlider.noUiSlider.set([filtersViewModel.price().min_default, filtersViewModel.price().max_default]);
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'status_sell':
                filtersViewModel.statusSell(false);
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'city':
                filtersViewModel.cityId('all');
                filtersViewModel.areaUrl('all');
                filtersViewModel.areaChange();
                filtersViewModel.zones(filtersViewModel.allZoneOption());
                filtersViewModel.geographicalAreas(filtersViewModel.allGeographicalAreaOption());                
                $('#filter-city').trigger('change');
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'area':
                filtersViewModel.areaUrl('all');
                $('#filter-area').trigger('change');
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'zone':
                filtersViewModel.areaUrl('all');
                $('#filter-area').trigger('change');
                filtersViewModel.zoneId('all');
                $('#filter-zone').trigger('change');
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'geographical_area':
                filtersViewModel.geographicalAreaId('all');
                $('#filter-geographical-area').trigger('change');
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'sort':
                filtersViewModel.sortedBy(filtersViewModel.sortList()[0]);
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'pool_width':
                filtersViewModel.poolWidth().min = filtersViewModel.poolWidth().min_default;
                filtersViewModel.poolWidth().max = filtersViewModel.poolWidth().max_default;
                filtersViewModel.poolWidthSlider.noUiSlider.set([filtersViewModel.poolWidth().min_default, filtersViewModel.poolWidth().max_default]);
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'pool_length':
                filtersViewModel.poolLength().min = filtersViewModel.poolLength().min_default;
                filtersViewModel.poolLength().max = filtersViewModel.poolLength().max_default;
                filtersViewModel.poolLengthSlider.noUiSlider.set([filtersViewModel.poolLength().min_default, filtersViewModel.poolLength().max_default]);
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;

            case 'pool_depth':
                filtersViewModel.poolDepth().min = filtersViewModel.poolDepth().min_default;
                filtersViewModel.poolDepth().max = filtersViewModel.poolDepth().max_default;
                filtersViewModel.poolDepthSlider.noUiSlider.set([filtersViewModel.poolDepth().min_default, filtersViewModel.poolDepth().max_default]);
                if (doSubmit)
                    filtersViewModel.submitFilter();
                break;
        }
    },

    clearFilters: function(exceptTag = [], submit=true) {
        filtersViewModel.activeSubmit = false;

        var tags = filtersViewModel.tags().slice(0);
        var hasExcept = exceptTag.length > 0;
        $.each(tags, function(index, tag) {
            if (hasExcept) {
                if (exceptTag.includes(tag.type))
                    return false;
            }

            filtersViewModel.removeTag(tag);
        });

        filtersViewModel.activeSubmit = true;
        if (submit)
            filtersViewModel.submitFilter();
    },

    init: function() {
        this.initCities();

        // Set q parameter from query string
        if (window.Q.length > 0) {
            this.name(window.Q);
            this.updateName();
        }

        // Check vicinity pools
        if (window.VICINITY === true) {
            filtersViewModel.tags.push({
                type: 'vicinity',
                query: 'lat=' + filtersViewModel.getQueryStringValue('lat') + '&lng=' + filtersViewModel.getQueryStringValue('lng'),
                title: 'مجموعه‌های اطراف من',
            });
        }

        filtersViewModel.statusSell(window.STATUS_SELL);
        if (filtersViewModel.statusSell())
            filtersViewModel.tags.push(filtersViewModel.statusSellTag());

        this.sortList(JSON.parse(window.sortList));
        this.changeSort(JSON.parse(window.sortedBy));

        this.loadData();
        this.initSaensTimeSlider();
        this.initPriceSlider();
        this.initPoolWidthSlider();
        this.initPoolLengthSlider();
        this.initPoolDepthSlider();

        filtersViewModel.poolsCount(window.poolsCount);
        filtersViewModel.poolsCountFa(filtersViewModel.poolsCount().toString().toPersianDigits());

        filtersViewModel.afterFirstRequest(true);
    },

    loadData: function() {
        var that = this;
        var queryParameters = window.location.search.substring(1);

        // Set ServiceCategory
        if (window.SERVICE_CATEGORY_ID != that.allServiceCategory) {
            var serviceCategory = 'service_category_id='+window.SERVICE_CATEGORY_ID;
            if (queryParameters.length > 0)
                serviceCategory = '&' + serviceCategory;

            queryParameters += serviceCategory;
        }

        // Set Service
        if (window.SERVICE != that.allServiceType) {
            var service = 'service_type='+window.SERVICE;
            if (queryParameters.length > 0)
                service = '&' + service;

            queryParameters += service;
        }

        // If has only one Attribute, Set it to url parameter`s
        if (window.HAS_ONLY_ONE_ATTRIBUTE != that.hasNotOnlyOneAttribute) {
            var attribute = 'attrs='+window.HAS_ONLY_ONE_ATTRIBUTE;
            if (queryParameters.length > 0)
                attribute = '&' + attribute;

            queryParameters += attribute;
        }

        // If has Tag, Set it to url parameter`s
        if (window.TAG != that.noTagSelected) {
            let tag = 'tag='+window.TAG;
            if (queryParameters.length > 0)
                tag = '&' + tag;

            queryParameters += tag;
        }

        // If has Area, Set it to url parameter`s
        if (window.AREA != that.noAreaSelected) {
            let area = 'area='+window.AREA;
            if (queryParameters.length > 0)
                area = '&' + area;

            queryParameters += area;
        }

        var cityId = $('#filter-city').val();

        $.ajax({
            url: window.BASE_URL + '/pools/filter',
            method: 'post',
            data: 'city=' + cityId + '&' + queryParameters,
            success: function(data) {

                that.areas(that.allAreaOption().concat(data.areas));
                that.areaUrl(data.area_url);
                that.areaChange();

                that.zones(that.allZoneOption().concat(data.zones));
                that.zoneId(data.zone_id);

                that.geographicalAreas(that.allGeographicalAreaOption().concat(data.geographical_areas));
                that.geographicalAreaId(data.geographical_area_id);

                that.services(data.services.list);
                that.selectedService(data.services.selected);
                that.refreshServiceTag();
                that.setServicesByCategory(data.services.group_by_categories);

                that.serviceCategories(data.service_categories.list);
                that.selectedServiceCategory(data.service_categories.selected);
                that.refreshServiceCategoryTag();
                // Open category collapse
                let selectedServiceCategory = that.selectedServiceCategory();
                if (selectedServiceCategory != that.allServiceCategory) {
                    $(`#collapse-services`).collapse('show');
                    $(`#collapse-service-category-${selectedServiceCategory}`).collapse('show');
                }

                that.attributes(data.attributes.list);
                that.selectedAttributes(data.attributes.selected);
                that.refreshAttributesTags();

                that.f_gender(data.gender);
                that.genderSet();

                if (data.tag) {
                    that.tags.push({
                        type: 'tag',
                        value: data.tag.url,
                        title: data.tag.name
                    });
                }
            },
            error: function() {

            }
        });
    },

    serviceChange: function() {
        let serviceCategoryId = filtersViewModel.getCategoryByServiceType(filtersViewModel.selectedService());
        filtersViewModel.selectedServiceCategory(serviceCategoryId);
        filtersViewModel.refreshAttributesTags();
        filtersViewModel.refreshServiceTag();
        filtersViewModel.refreshServiceCategoryTag();
        filtersViewModel.submitFilter();
    },

    serviceCategoryChange: function() {
        filtersViewModel.selectedService(filtersViewModel.allServiceType);

        let selectedServiceCategoryId = filtersViewModel.selectedServiceCategory();

        // Open category collapse
        if (filtersViewModel.hasServiceInCategory(selectedServiceCategoryId))
            $(`#collapse-service-category-${selectedServiceCategoryId}`).collapse('show');

        filtersViewModel.refreshAttributesTags();
        filtersViewModel.refreshServiceTag();
        filtersViewModel.refreshServiceCategoryTag();
        filtersViewModel.submitFilter();
    },

    refreshServiceCategoryTag: function() {
        var that = this;
        filtersViewModel.removeTagWhere(['type', 'service_category']);

        if (filtersViewModel.selectedServiceCategory() === '')
            return;

        if (filtersViewModel.selectedService() != this.allServiceType)
            return;

        $.each(filtersViewModel.serviceCategories(), function(index, serviceCategory) {
            if (filtersViewModel.selectedServiceCategory() === serviceCategory.service_category_id) {

                if (serviceCategory.service_category_id == that.allServiceCategory) // if service is all, dont show any tag about service
                    return;

                filtersViewModel.tags.push({
                    type: 'service_category',
                    value: serviceCategory.url,
                    title: serviceCategory.title,
                    service_category_id: serviceCategory.service_category_id,
                    ignore_query: true
                });

                return;
            }
        });
    },

    refreshServiceTag: function() {
        var that = this;
        filtersViewModel.removeTagWhere(['type', 'service']);

        if (filtersViewModel.selectedService() === '')
            return;

        $.each(filtersViewModel.services(), function(index, service) {
            if (filtersViewModel.selectedService() === service.service_type) {

                if (service.service_type == that.allServiceType) // if service is all, dont show any tag about service
                    return;

                filtersViewModel.tags.push({
                    type: 'service',
                    value: service.url,
                    title: service.title,
                    ignore_query: true
                });
            }
        });
    },

    setServicesByCategory: function() {
        var services = filtersViewModel.services();
        let servicesByCategory = services.reduce((acc, service) => {
            const categoryId = service.service_category_id;

            // If the category doesn't exist in the accumulator, create it
            if (!acc[categoryId]) {
                acc[categoryId] = [];
            }

            // Push the service into the appropriate category
            acc[categoryId].push(service);

            return acc;
        }, {});

        filtersViewModel.servicesByCategory(servicesByCategory);
    },

    getServicesByCategory: function(categoryId) {
        if (categoryId == filtersViewModel.allServiceCategory) {
            return [];
        }

        return filtersViewModel.servicesByCategory()[categoryId] ?? [];
    },

    hasServiceInCategory: function(categoryId) {
        if (categoryId == filtersViewModel.allServiceCategory)
            return false;

        return (filtersViewModel.servicesByCategory()[categoryId]?.length > 0) ?? false; // ?. means prevent crash if is undefined 
    },

    saensTimeChange: function() {
        this.removeTagWhere(['type', 'saens_time']);

        if (this.saensTime().min == 0 && this.saensTime().max == 24)
            return;

        filtersViewModel.tags.push({
            type: 'saens_time',
            query: 'saens_time[min]=' + this.saensTime().min + '&saens_time[max]=' + this.saensTime().max,
            title: 'از ساعت ' + this.timeFormat(this.saensTime().min + 6) + ' تا ' + this.timeFormat(this.saensTime().max + 6),
            min: this.saensTime().min,
            max: this.saensTime().max,
        });
    },

    priceChange: function() {
        this.removeTagWhere(['type', 'price']);

        if (this.price().min_default == this.price().min && this.price().max_default == this.price().max)
            return;

        filtersViewModel.tags.push({
            type: 'price',
            query: 'price[min]=' + this.price().min + '&price[max]=' + this.price().max,
            title: 'از ' + this.price().min.toString().thousandSeparator().toPersianDigits() + ' تا ' + this.price().max.toString().thousandSeparator().toPersianDigits() + ' تومان',
            min: this.price().min,
            max: this.price().max,
        });
    },

    poolWidthChange: function() {
        this.removeTagWhere(['type', 'pool_width']);

        if (this.poolWidth().min_default == this.poolWidth().min && this.poolWidth().max_default == this.poolWidth().max)
            return;

        filtersViewModel.tags.push({
            type: 'pool_width',
            query: 'pool_width[min]=' + this.poolWidth().min + '&pool_width[max]=' + this.poolWidth().max,
            title: 'عرض استخر از ' + this.poolWidth().min.toString().toPersianDigits() + ' تا ' + this.poolWidth().max.toString().toPersianDigits() + ' متر',
            min: this.poolWidth().min,
            max: this.poolWidth().max,
        });
    },

    poolLengthChange: function() {
        this.removeTagWhere(['type', 'pool_length']);

        if (this.poolLength().min_default == this.poolLength().min && this.poolLength().max_default == this.poolLength().max)
            return;

        filtersViewModel.tags.push({
            type: 'pool_length',
            query: 'pool_length[min]=' + this.poolLength().min + '&pool_length[max]=' + this.poolLength().max,
            title: 'طول استخر از ' + this.poolLength().min.toString().toPersianDigits() + ' تا ' + this.poolLength().max.toString().toPersianDigits() + ' متر',
            min: this.poolLength().min,
            max: this.poolLength().max,
        });
    },

    poolDepthChange: function() {
        this.removeTagWhere(['type', 'pool_depth']);

        if (this.poolDepth().min_default == this.poolDepth().min && this.poolDepth().max_default == this.poolDepth().max)
            return;

        filtersViewModel.tags.push({
            type: 'pool_depth',
            query: 'pool_depth[min]=' + this.poolDepth().min + '&pool_depth[max]=' + this.poolDepth().max,
            title: 'عمق استخر از ' + this.poolDepth().min.toString().toPersianDigits() + ' تا ' + this.poolDepth().max.toString().toPersianDigits() + ' متر',
            min: this.poolDepth().min,
            max: this.poolDepth().max,
        });
    },

    initPriceSlider: function() {
        let that = this;

        this.price().min = isNaN(parseInt($('#min-price').text())) ? this.price().min_default : parseInt($('#min-price').text());
        this.price().max = isNaN(parseInt($('#max-price').text())) ? this.price().max_default : parseInt($('#max-price').text());

        this.priceChange();

        this.priceSlider = document.getElementById('price-range');
        noUiSlider.create(this.priceSlider, {
            start: [this.price().min, this.price().max],
            connect: true,
            step: 10000,
            margin: 10000,
            direction: 'rtl',
            range: {
                'min': this.price().min_default,
                'max': this.price().max_default
            }
        });

        this.priceSlider.noUiSlider.on('change', function (values) {
            let min = parseInt(values[0]);
            let max = parseInt(values[1]);
            document.getElementById('min-price').innerHTML = min.toString().thousandSeparator().toPersianDigits();
            document.getElementById('max-price').innerHTML = max.toString().thousandSeparator().toPersianDigits();

            that.price($.extend(that.price(), {
                min: min,
                max: max
            }));

            filtersViewModel.enableButton('#update-price');
        });

        this.priceSlider.noUiSlider.on('update', function (values) {
            let min = parseInt(values[0]);
            let max = parseInt(values[1]);
            document.getElementById('min-price').innerHTML = min.toString().thousandSeparator().toPersianDigits();
            document.getElementById('max-price').innerHTML = max.toString().thousandSeparator().toPersianDigits();
        });
    },

    updatePrice: function() {
        filtersViewModel.submitFilter();
    },

    initPoolWidthSlider: function() {
        let that = this;

        this.poolWidth().min = isNaN(parseInt($('#min-pool-width').text())) ? this.poolWidth().min_default : parseInt($('#min-pool-width').text());
        this.poolWidth().max = isNaN(parseInt($('#max-pool-width').text())) ? this.poolWidth().max_default : parseInt($('#max-pool-width').text());

        this.poolWidthChange();

        this.poolWidthSlider = document.getElementById('pool-width-range');
        noUiSlider.create(this.poolWidthSlider, {
            start: [this.poolWidth().min, this.poolWidth().max],
            connect: true,
            step: 1,
            margin: 1,
            direction: 'rtl',
            range: {
                'min': this.poolWidth().min_default,
                'max': this.poolWidth().max_default
            }
        });

        this.poolWidthSlider.noUiSlider.on('change', function (values) {
            let min = parseInt(values[0]);
            let max = parseInt(values[1]);
            document.getElementById('min-pool-width').innerHTML = min.toString().toPersianDigits();
            document.getElementById('max-pool-width').innerHTML = max.toString().toPersianDigits();

            that.poolWidth($.extend(that.poolWidth(), {
                min: min,
                max: max
            }));

            filtersViewModel.enableButton('#update-dimension');
        });

        this.poolWidthSlider.noUiSlider.on('update', function (values) {
            let min = parseInt(values[0]);
            let max = parseInt(values[1]);
            document.getElementById('min-pool-width').innerHTML = min.toString().toPersianDigits();
            document.getElementById('max-pool-width').innerHTML = max.toString().toPersianDigits();
        });
    },

    initPoolLengthSlider: function() {
        let that = this;

        this.poolLength().min = isNaN(parseInt($('#min-pool-length').text())) ? this.poolLength().min_default : parseInt($('#min-pool-length').text());
        this.poolLength().max = isNaN(parseInt($('#max-pool-length').text())) ? this.poolLength().max_default : parseInt($('#max-pool-length').text());

        this.poolLengthChange();

        this.poolLengthSlider = document.getElementById('pool-length-range');
        noUiSlider.create(this.poolLengthSlider, {
            start: [this.poolLength().min, this.poolLength().max],
            connect: true,
            step: 1,
            margin: 1,
            direction: 'rtl',
            range: {
                'min': this.poolLength().min_default,
                'max': this.poolLength().max_default
            }
        });

        this.poolLengthSlider.noUiSlider.on('change', function (values) {
            let min = parseInt(values[0]);
            let max = parseInt(values[1]);
            document.getElementById('min-pool-length').innerHTML = min.toString().toPersianDigits();
            document.getElementById('max-pool-length').innerHTML = max.toString().toPersianDigits();

            that.poolLength($.extend(that.poolLength(), {
                min: min,
                max: max
            }));

            filtersViewModel.enableButton('#update-dimension');
        });

        this.poolLengthSlider.noUiSlider.on('update', function (values) {
            let min = parseInt(values[0]);
            let max = parseInt(values[1]);
            document.getElementById('min-pool-length').innerHTML = min.toString().toPersianDigits();
            document.getElementById('max-pool-length').innerHTML = max.toString().toPersianDigits();
        });
    },

    initPoolDepthSlider: function() {
        let that = this;

        this.poolDepth().min = isNaN(parseFloat($('#min-pool-depth').text())) ? this.poolDepth().min_default : parseFloat($('#min-pool-depth').text());
        this.poolDepth().max = isNaN(parseFloat($('#max-pool-depth').text())) ? this.poolDepth().max_default : parseFloat($('#max-pool-depth').text());

        this.poolDepthChange();

        this.poolDepthSlider = document.getElementById('pool-depth-range');
        noUiSlider.create(this.poolDepthSlider, {
            start: [this.poolDepth().min, this.poolDepth().max],
            connect: true,
            step: 0.5,
            margin: 0.5,
            direction: 'rtl',
            range: {
                'min': this.poolDepth().min_default,
                'max': this.poolDepth().max_default
            }
        });

        this.poolDepthSlider.noUiSlider.on('change', function (values) {
            let min = parseFloat(values[0]);
            let max = parseFloat(values[1]);
            document.getElementById('min-pool-depth').innerHTML = min.toString().toPersianDigits();
            document.getElementById('max-pool-depth').innerHTML = max.toString().toPersianDigits();

            that.poolDepth($.extend(that.poolDepth(), {
                min: min,
                max: max
            }));

            filtersViewModel.enableButton('#update-dimension');
        });

        this.poolDepthSlider.noUiSlider.on('update', function (values) {
            let min = parseFloat(values[0]);
            let max = parseFloat(values[1]);
            document.getElementById('min-pool-depth').innerHTML = min.toString().toPersianDigits();
            document.getElementById('max-pool-depth').innerHTML = max.toString().toPersianDigits();
        });
    },

    updateDimension: function() {
        filtersViewModel.submitFilter();
    },

    initSaensTimeSlider: function() {
        let that = this;

        this.saensTime().min = isNaN(parseInt($('#min-time').text())) ? this.saensTime().min_default : parseInt($('#min-time').text());
        this.saensTime().max = isNaN(parseInt($('#max-time').text())) ? this.saensTime().max_default : parseInt($('#max-time').text());

        this.saensTimeChange();

        this.saensTimeSlider = document.getElementById('time-range');
        noUiSlider.create(this.saensTimeSlider, {
            start: [this.saensTime().min + 6, this.saensTime().max + 6],
            connect: true,
            step: 1,
            direction: 'rtl',
            padding: [19, 0],
            margin: 1,
            range: {
                'min': this.saensTime().min_default - 13,
                'max': this.saensTime().max_default + 6
            }
        });

        this.saensTimeSlider.noUiSlider.on('change', function (values) {
            filtersViewModel.enableButton('#update-time');

            document.getElementById('min-time').innerHTML = `<span class="ltr">${that.timeFormat(values[0])}</span>`;
            document.getElementById('max-time').innerHTML = `<span class="ltr">${that.timeFormat(values[1])}</span>`;

            document.querySelector('#time-range .noUi-handle-lower .noUi-touch-area').innerHTML = that.timeFormat(values[0]);
            document.querySelector('#time-range .noUi-handle-upper .noUi-touch-area').innerHTML = that.timeFormat(values[1]);

            that.saensTime($.extend(that.saensTime(), {
                min: values[0] - 6,
                max: values[1] - 6
            }));
        });

        this.saensTimeSlider.noUiSlider.on('update', function (values) {
            document.getElementById('min-time').innerHTML = `<span class="ltr">${that.timeFormat(values[0])}</span>`;
            document.getElementById('max-time').innerHTML = `<span class="ltr">${that.timeFormat(values[1])}</span>`;

            document.querySelector('#time-range .noUi-handle-lower .noUi-touch-area').innerHTML = that.timeFormat(values[0]);
            document.querySelector('#time-range .noUi-handle-upper .noUi-touch-area').innerHTML = that.timeFormat(values[1]);
        });
    },

    updateTime: function() {
        filtersViewModel.submitFilter();
    },

    disableButton: function(buttonId) {
        $(buttonId).prop('disabled', true);
        $(buttonId).removeClass('btn-outline-primary').addClass('btn-outline-secondary');
    },

    enableButton: function(buttonId) {
        $(buttonId).prop('disabled', false);
        $(buttonId).removeClass('btn-outline-secondary').addClass('btn-outline-primary');
    },

    updateName: function() {
        var name = this.name();
        this.removeTagWhere(['type', 'name']);

        if (name !== undefined && name.length > 0) {
            this.tags.push({
                type: 'name',
                value: name,
                title: name
            });
        }
    },

    timeFormat: function(value) {
        var toNumber = Number(value) - 6;

        if (toNumber < 10 ) {
            return `0${toNumber}:00`.toPersianDigits();
        } else {
            if (toNumber == 24)
                return "23:59".toPersianDigits();

            return `${toNumber}:00`.toPersianDigits();
        }
    },

    attributeChange: function() {
        filtersViewModel.refreshAttributesTags();
        filtersViewModel.submitFilter();
    },

    refreshAttributesTags: function() {
        filtersViewModel.removeTagWhere(['type', 'attr'], true);
        $.each(filtersViewModel.attributes(), function(index, attr) {
            if (filtersViewModel.selectedAttributes().indexOf(attr.attribute_id) >= 0) {
                filtersViewModel.tags.push({
                    type: 'attr',
                    queryStringType: 'array',
                    value: attr.url,
                    title: attr.name,
                    attribute_id: attr.attribute_id
                });
            }
        });
    },

    getQueryStringValue: function(key) {
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    },

    getCitySegment: function() {
        path = window.location.pathname[0] == '/' ? window.location.pathname.substr(1) : window.location.pathname;
        path = path.split('/');
        if (path.length > 1) {
            return decodeURIComponent(path[1]);
        }

        return 'all';
    },

    changeSort: function(sortBy) {
        filtersViewModel.removeTagWhere(['type', 'sort']);

        filtersViewModel.sortedBy(sortBy);

        if (filtersViewModel.sortedBy().code !== filtersViewModel.defaultSort) {
            filtersViewModel.tags.push({
                type: 'sort',
                value: filtersViewModel.sortedBy().code,
                title: filtersViewModel.sortedBy().title,
                ignore_query: true
            });
        }

        if (filtersViewModel.afterFirstRequest())
            filtersViewModel.submitFilter();
    },

    getSort: function() {
        if (filtersViewModel.sortedBy().code == this.defaultSort) {
            return '';
        }

        return 'sort=' + filtersViewModel.sortedBy().code;
    },

    changeViewType: function(value) {
        filtersViewModel.tags.push({
            type: 'view_type',
            value: value,
            title: 'نمایش',
            ignore_query: false
        });

        filtersViewModel.refreshPage(filtersViewModel.buildUrl());

        return false;
    },

    initCities: function() {
        // City select2
        filtersViewModel.citySelect2 = $('#filter-city').select2({
            placeholder: "شهر",
            data: JSON.parse(window.activeCities),
            minimumInputLength: 0,
            dir: 'rtl',
            language: 'fa'
        })
        .on('select2:open', function(event) {
            $('#select2-filter-city-results').parents('.select2-dropdown').find('.select2-search')
                .append('<div class="map">'+'<a id="vicinity-pools" href="javascript:void(0)" class="btn btn-outline-primary btn-vicinity">'+'<i class="icon icon-map-pin-marked right"></i>'+'مجموعه های اطراف من'+'<i class="icon icon-arrow_back left"></i>'+'</a>'+'</div>');
            $('#select2-filter-city-results').parents('.select2-dropdown').find('.select2-search input').attr("placeholder", "جستجو شهر..");
        })
        .on('select2:select', function(event) {
            filtersViewModel.submitFilter();
        })
        .on('select2:closing', function(event) {
            $('#select2-filter-city-results').parents('.select2-dropdown').find('.select2-search .map').remove();
        })
        .val($('#filter-city').attr('value')).trigger('change');

        // Area select2
        $('#filter-area').select2({
            placeholder: "همه محله‌ها",
            minimumInputLength: 0,
            dir: 'rtl',
            language: 'fa'
        })
        .on('select2:open', function(event) {
            $('#select2-filter-area-results').parents('.select2-dropdown').find('.select2-search input').attr("placeholder", "جستجو محله..");
        })
        .on('select2:select', function(event) {
            filtersViewModel.submitFilter();
        })
        .val($('#filter-area').attr('value')).trigger('change');

        // Zone select2
        $('#filter-zone').select2({
            placeholder: "همه منطقه‌ها",
            minimumInputLength: 0,
            dir: 'rtl',
            language: 'fa'
        })
        .on('select2:open', function(event) {
            $('#select2-filter-zone-results').parents('.select2-dropdown').find('.select2-search input').attr("placeholder", "جستجو منطقه..");
        })
        .on('select2:select', function(event) {
            filtersViewModel.submitFilter();
        })
        .val($('#filter-zone').attr('value')).trigger('change');

        $('#filter-zone-section').find('.select2-container').css("width", "100%");

        // Geographical area select2
        $('#filter-geographical-area').select2({
            placeholder: "همه منطقه‌های جغرافیایی",
            minimumInputLength: 0,
            dir: 'rtl',
            language: 'fa'
        })
        .on('select2:open', function(event) {
            $('#select2-filter-geographical-area-results').parents('.select2-dropdown').find('.select2-search input').attr("placeholder", "جستجو منطقه جغرافیایی..");
        })
        .on('select2:select', function(event) {
            filtersViewModel.submitFilter();
        })
        .val($('#filter-geographical-area').attr('value')).trigger('change');

        $('#filter-geographical-area-section').find('.select2-container').css("width", "100%");
    }
};

filtersViewModel.name($('#name').val());

ko.applyBindings(filtersViewModel, document.getElementById('pools-page'));

filtersViewModel.init();

$(function() {
    $(document).on('click', '.pagination-container a', function(e) {
        e.preventDefault();
        filtersViewModel.request($(this).attr('href'), true);
        $('html,body').scrollTop(0);
    });

    $(window).on('popstate', function() {
        if (document.location.hash.length > 0) {
            return;
        }

        filtersViewModel.init();
        filtersViewModel.request(document.location, false, function(data) {
            // Set City
            filtersViewModel.citySelect2.val(filtersViewModel.getCitySegment()).trigger('change');

            // Set Name
            filtersViewModel.name(filtersViewModel.getQueryStringValue('name'));
        });
    });

    carouselSlider();
    seoNavLinksCarousel();
    servicesSuggestLinksCarousel();
});

function carouselSlider() {
    $('.slider-with-navs').owlCarousel({
        items: 1,
        rtl: true,
        autoplay: false,
        nav: true,
        navText: ['<i class="icon icon-angle-right"></i>','<i class="icon icon-angle-left"></i>'],
        loop: true,
        lazyLoad: true,
    });
}

// Seo nav links carousel
function seoNavLinksCarousel() {
    $('#seo-nav-links').owlCarousel({
        margin: 11,
        rtl: true,
        autoplay: false,
        lazyLoad: true,
        nav: true,
        dots: false,
        loop: false,
        autoWidth:true,
        navText: [
            "<i class='icon icon-angle-right'></i>",
            "<i class='icon icon-angle-left'></i>",
        ],
    });
}

// Services suggest links carousel
function servicesSuggestLinksCarousel() {
    $('#services-suggest-links').owlCarousel({
        margin: 11,
        rtl: true,
        autoplay: false,
        lazyLoad: true,
        nav: true,
        dots: false,
        loop: false,
        autoWidth:true,
        navText: [
            "<i class='icon icon-angle-right'></i>",
            "<i class='icon icon-angle-left'></i>",
        ],
    });
}